'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002emain$0024package$0024 from "./presto.main$package$.js";
var $p;
function $s_Lpresto_main__main__AT__V(args) {
  try {
    $j_presto$002emain$0024package$0024.$m_Lpresto_main$package$().cL7();
  } catch (e) {
    if (false) {
      $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_CommandLineParser$().cPj(e);
    } else {
      throw e;
    }
  }
}
export { $s_Lpresto_main__main__AT__V as $s_Lpresto_main__main__AT__V };
//# sourceMappingURL=presto.main.js.map
